import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import noDataAvailable from '../../../Images/noDataAvailable.svg';
import { getAssetPortfolioWidget } from '../../../config/apiConfig';
import { sbaAxios } from '../../utils/sbaAxios';
import { AgGridReact } from "ag-grid-react";


export const AssetPortfolioHoldings = () => {
    const params = useParams();
    const [torender, SetToRender] = useState(false);
    const [assetPortfolios, setAssetPortfolios] = useState([]);

    const colDefs = [
        {headerName: "Portfolio Name", field: "PortfolioName",tooltipField:"PortfolioName",  flex:1},
        { 
            headerName: "Market Value", 
            field: "MarketValue",
            valueFormatter: (params) => {
                return new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }).format(params.value);
            }, 
            flex: 0.5
          },
    ]
    const defaulColumns = { filter: false };
   
    const dispatch = useDispatch();
    const assetID = params.Asset;

    const fetchAssetPortfolio = async() => {
        try{
            const list = await sbaAxios({
                url: getAssetPortfolioWidget,
                params:{
                    assetId: assetID
                }
            });
            setAssetPortfolios(list);
        }
        catch(e){
            setAssetPortfolios([]);
        }
    }
   
    useEffect(() => {
        fetchAssetPortfolio(); 
    }, []);
    const Gstate = useSelector((state) => state);
    const AssetSettings = useSelector(state => state.assetSettings);
    const currentAsset = Gstate.asset.asset || {};
   
    const portfolioHoldings=currentAsset.PortfolioHoldings;
    return (
        <>
        {assetPortfolios.length === 0 ? 
            <div className='d-flex w-100 my-4 h-100'>
                <img src={noDataAvailable} alt='NO DATA AVAILABLE' className='m-auto' width={'30%'} />
            </div>:
            <div className="ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
                <AgGridReact 
                    rowData={assetPortfolios}
                    columnDefs={colDefs}
                    defaultColDef={defaulColumns}
                >
                </AgGridReact>
            </div>
        }
        </>
    )
}
